var React = require('react');

function DepopRoundedLogo (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0)"},React.createElement("g",{"transform":"translate(0 0)"},[React.createElement("circle",{"cx":"18","cy":"18","r":"18","transform":"translate(0 0)","fill":"#E20020","key":0}),React.createElement("path",{"fill":"#FFFFFF","d":"M93.614,86.02v5h-4.03c-3.9,0-6.333,2.1-6.333,5.514,0,3.188,2.436,5.2,6.312,5.2h9.1V86.02Zm0,12.334h-2.7c-1.528,0-2.326-.686-2.326-1.993,0-1.329.819-2.015,2.347-2.015h2.68Z","transform":"translate(-74.169 -76.591)","key":1})])));
}

DepopRoundedLogo.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36"};

module.exports = DepopRoundedLogo;

DepopRoundedLogo.default = DepopRoundedLogo;
